<template>
  <div class="column-wrapper">
    <ui-slide-down :open="isOpen" :disableClicks="isDisableClick">
      <template #header="{ visible }">
        <div class="column-title-wrapper">
          <div v-if="title" class="column-title heading-s">
            {{ title }}
          </div>
          <div class="is-body-opened" :class="{ closed: !visible }" />
        </div>
      </template>
      <template #default>
        <ul v-if="links.length" class="column-items">
          <li
            v-for="(link, i) in links"
            :key="`column-item${i}${title}`"
            class="column-item body-l-regular"
          >
            <nuxt-link :to="link.to">{{ link.name }}</nuxt-link>
            <UiIcon
              class="icon-wrapper"
              v-if="link?.icon"
              name="vk-new"
              alt="Вк"
              :response-size="[16, 16, 16, 22, 22, 24]"
            />
          </li>
          <slot />
        </ul>
      </template>
    </ui-slide-down>
  </div>
</template>

<script setup lang="ts">
defineProps({
  links: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  isDisableClick: {
    type: Boolean,
    default: false,
  },
});
</script>
<style scoped lang="scss">
.column-wrapper {
  color: white;

  .column-title-wrapper {
    display: flex;
    justify-content: space-between;
    @include sm-block {
      justify-content: flex-start;
    }
  }

  .column-title {
    //text-transform: uppercase;
    //margin-bottom: 12px;
    //@include xxl-block {
    //  margin-bottom: 16px;
    //}
  }

  .column-items {
    .column-item {
      display: flex;

      &:first-child {
        margin-top: 12px;
        @include xxl-block {
          margin-top: 16px;
        }
      }

      &:not(:first-child) {
        margin-top: 12px;
        @include md-block {
          margin-top: 12px;
        }
        @include xxl-block {
          margin-top: 16px;
        }
      }
    }
  }

  .is-body-opened {
    width: 20px;
    height: 20px;
    background: {
      image: url('/static/images/arrow-up-white.svg');
      size: 100%;
      repeat: no-repeat;
      position: center;
    }
    margin-left: 8px;
    flex-shrink: 0;

    &.closed {
      transform: rotate(180deg);
    }

    @include sm-block {
      display: none;
    }
  }

  .icon-wrapper {
    margin-left: 8px;
    @include lg-block {
      margin-left: 9px;
    }
  }

  :deep(.slide-header) {
    cursor: default;
  }
}

:deep(.droped-content-wrap) {
  transition: height 120ms ease-out !important;
}
</style>
